export default __webpack_public_path__ + "static/media/DNo.11-1.a91d3d7d.jpg";